export interface ShiftStorageKey {
    shiftIndex: number;
    externalJobId: string;
}

export const createShiftStorageKey = (externalJobId: string, shiftIndex: number): ShiftStorageKey => ({
    externalJobId,
    shiftIndex
});
